module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./wrapped.md");


//////////////////
// WEBPACK FOOTER
// ./src/assets/posts/wrapped.md
// module id = 30
// module chunks = 1